<template>
  <div>
    <div class="style-2 home s-2 bottom-3">

      <div class="container clearfix">

        <h3 class="title inline bold" style="font-weight: bold;">
          {{ $t('comp_title_1') }}
        </h3>

        <a id="techtoggle" @click="techShowMore=!techShowMore" style="cursor: pointer">
          <span v-if="techShowMore">({{ $t('comp_show_less') }})</span>
          <span v-else>({{ $t('comp_show_more') }})</span>
        </a>

        <div class="row">
          <div class="sixteen columns bottom-3 technologies">
            <p>

              <strong>Databases </strong>
              <transition name="tech" tag="span" mode="out-in">
                <span class="tc" v-if="techShowMore" key="tech_1"> Oracle (PL/SQL), PostgreSQL (PL/pgSQL), MySQL, MS-SQL </span>
                <span v-else>&nbsp;</span>
              </transition>

              <strong>Java technologies </strong>
              <transition name="tech" tag="span" mode="out-in">
                <span class="tc" v-if="techShowMore" key="tech_2"> Spring (WebMVC, Boot, Security, Data), Google App Engine, JEE (Servlet, JSP, JSTL, JDBC), JPA (Hibernate), OSGi, Build systems (Gradle, Maven, Ant), Oracle Coherence Cache Cluster &amp; Distributed Computing Framework, Vaadin </span>
                <span v-else>&nbsp;</span>
              </transition>

              <strong>Java libraries </strong>
              <transition name="tech" tag="span" mode="out-in">
                <span class="tc" v-if="techShowMore" key="tech_3"> Metro, Apache CXF, Lucene, Elasticsearch, Quartz, Log4J, SLF4J, Mina, CAS, NIO, iText, Apache Commons, Guava, XSL </span>
                <span v-else>&nbsp;</span>
              </transition>

              <strong>Application servers </strong>
              <transition name="tech" tag="span" mode="out-in">
                <span class="tc" v-if="techShowMore" key="tech_4"> IAS, Tomcat, JBoss, WebLogic </span>
                <span v-else>&nbsp;</span>
              </transition>

              <strong>Portal engines </strong>
              <transition name="tech" tag="span" mode="out-in">
                <span class="tc" v-if="techShowMore" key="tech_5"> Oracle Portal, Gridsphere, Liferay, Jakarta Jetspeed </span>
                <span v-else>&nbsp;</span>
              </transition>

              <strong>IDE &amp; dev tools </strong>
              <transition name="tech" tag="span" mode="out-in">
                <span class="tc" v-if="techShowMore" key="tech_6"> Eclipse, Netbeans, JDeveloper, Jenkins, Sonar </span>
                <span v-else>&nbsp;</span>
              </transition>

              <strong>Special APIs </strong>
              <transition name="tech" tag="span" mode="out-in">
                <span class="tc" v-if="techShowMore" key="tech_7"> OTA (Open Travel Agency), Google Maps, Google Drive & Apps, electronic payment gateways (Paypal, bank web POS terminals), various JSON / XML / REST APIs </span>
                <span v-else>&nbsp;</span>
              </transition>

              <strong>Version Control </strong>
              <transition name="tech" tag="span" mode="out-in">
                <span class="tc" v-if="techShowMore" key="tech_8"> Subversion, CVS, SourceSafe, Git </span>
                <span v-else>&nbsp;</span>
              </transition>

              <strong>Configuration / customization </strong>
              <transition name="tech" tag="span" mode="out-in">
                <span class="tc" v-if="techShowMore" key="tech_9"> ForgeRock OpenAM, ActiveMQ (JMS), JIRA, Apache httpd, Splunk, Linux (Debian, Ubuntu, CentOS, RedHat), Lua </span>
                <span v-else>&nbsp;</span>
              </transition>

              <strong>Frontend </strong>
              <transition name="tech" tag="span" mode="out-in">
                <span class="tc" v-if="techShowMore" key="tech_10"> Vue.js, HTML5, CSS3, Sass, JavaScript, jQuery, Bootstrap (Responsive Web Design), Android, Node.js, NPM, Webpack </span>
                <span v-else>&nbsp;</span>
              </transition>

              <strong>Testing </strong>
              <transition name="tech" tag="span" mode="out-in">
                <span class="tc" v-if="techShowMore" key="tech_11"> JUnit, TestNG, TestLink, JMeter (custom sampler development), Selenium WebDriver, Robotframework, Codeception, PHPUnit, Dusk </span>
                <span v-else>&nbsp;</span>
              </transition>

              <strong>Architecture Design </strong>
              <transition name="tech" tag="span" mode="out-in">
              <span class="tc"
                    v-if="techShowMore" key="tech_12"> Enterprise Architect, Microsoft Visio, ArgoUML, Pencil for paper prototyping </span>
                <span v-else>&nbsp;</span>
              </transition>

              <strong>Project management </strong>
              <transition name="tech" tag="span" mode="out-in">
                <span class="tc"
                      v-if="techShowMore"
                      key="tech_13"> Microsoft Project, Mantis, Trac, Dokuwiki Asana, Basecamp and many other </span>
                <span v-else>&nbsp;</span>
              </transition>

              <strong>PHP </strong>
              <transition name="tech" tag="span" mode="out-in">
                <span class="tc" v-if="techShowMore" key="tech_14"> Laravel, Wordpress, Drupal, Magento, CodeIgniter </span>
                <span v-else>&nbsp;</span>
              </transition>

              <strong>Perl </strong>
              <transition name="tech" tag="span" mode="out-in">
                <span class="tc" v-if="techShowMore" key="tech_15"> OOP, DBI, LibXML, LDAP, IPC, networking </span>
                <span v-else>&nbsp;</span>
              </transition>

              <strong>Python </strong>
              <transition name="tech" tag="span" mode="out-in">
                <span class="tc" v-if="techShowMore" key="tech_16"> OOP, sqlite3, csv, json, REST, flask, smtplib </span>
                <span v-else>&nbsp;</span>
              </transition>

              <strong>C# ASP.NET </strong>
              <transition name="tech" tag="span" mode="out-in">
                <span class="tc" v-if="techShowMore" key="tech_17"> Entity Framework, MVC, IIS  </span>
                <span v-else>&nbsp;</span>
              </transition>

            </p>

          </div>
        </div>

        <div class="row">

          <div class="two-thirds column bottom-3">

            <h3 class="title">{{ $t('comp_title_2') }}</h3>

            <div id="accordion2" class="accordion style2 ui-accordion ui-widget ui-helper-reset" role="tablist">
              <div v-for="(areaItem,a_index) in areaList" :key="a_index">
                <h4 class="ui-accordion-header ui-helper-reset ui-accordion-icons ui-corner-all"
                    :class="[areaItem.open ? 'ui-state-active' : 'ui-state-default']"
                    v-on:click.stop="toggleArea(a_index)">

                  <i class="ui-accordion-header-icon ui-icon"
                     :class="[areaItem.open ? 'icon-minus' : 'icon-plus']"></i>
                  <a>{{ $t(areaItem.title) }}</a>
                </h4>
                <transition name="accordion" tag="p"
                            v-on:before-enter="beforeEnter" v-on:enter="enter"
                            v-on:before-leave="beforeLeave" v-on:leave="leave">

                  <div class="ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom"
                       v-show="areaItem.open">
                    <p v-for="(areaText, at_index) in areaItem.texts" :key="at_index">
                      {{ $t(areaText) }}
                    </p>
                  </div>
                </transition>
              </div>
            </div>

            <h3 class="title">{{ $t('comp_title_3') }}</h3>

            <div id="accordion3" class="accordion style2 ui-accordion ui-widget ui-helper-reset" role="tablist">
              <div v-for="(serviceItem,s_index) in servicesList" :key="s_index">
                <h4 class="ui-accordion-header ui-helper-reset ui-accordion-icons ui-corner-all"
                    :class="[serviceItem.open ? 'ui-state-active' : 'ui-state-default']"
                    v-on:click.stop="toggleService(s_index)">

                  <i class="ui-accordion-header-icon ui-icon"
                     :class="[serviceItem.open ? 'icon-minus' : 'icon-plus']"></i>
                  <a>{{ $t(serviceItem.title) }}</a>
                </h4>

                <transition name="accordion" tag="p"
                            v-on:before-enter="beforeEnter" v-on:enter="enter"
                            v-on:before-leave="beforeLeave" v-on:leave="leave">
                  <div class="ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom"
                       v-show="serviceItem.open">
                    <p v-for="(serviceText, st_index) in serviceItem.texts" :key="st_index">
                      {{ $t(serviceText) }}
                    </p>
                  </div>
                </transition>
              </div>
            </div>

          </div>

          <div class="one-third column bottom-3">
            <h3 class="title bottom-2">{{ $t('comp_title_4') }}</h3>

            <ul class="check-list why">
              <li v-for="(project, idx) in projects" :key="idx">
                <a>{{ $t(project) }}</a>
              </li>
            </ul>

            <img src="../../assets/images/ISTQB-International_original.png" class="badge"/>
            <img src="../../assets/images/nljug-pin.gif" class="badge"/>
          </div>

        </div>

      </div>

      <div class="sixteen columns clearfix"></div>

      <contact-banner></contact-banner>

    </div>
  </div>
</template>

<script>
import ContactBanner from '../utilities/ContactBanner'

export default {
  name: 'Competencies',
  components: { ContactBanner },
  methods: {
    toggleArea (item) {
      // dont change key == item to strict comparison
      for (let key in this.areaList) {
        if (key == item) {
          this.areaList[key].open = !this.areaList[key].open
        } else {
          this.areaList[key].open = false
        }
      }
    },
    toggleService (item) {
      // dont change key == item to strict comparison
      for (let key in this.servicesList) {
        if (key == item) {
          this.servicesList[key].open = !this.servicesList[key].open
        } else {
          this.servicesList[key].open = false
        }
      }
    },
    beforeEnter: function (el) {
      el.style.height = '0'
    },
    enter: function (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    beforeLeave: function (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave: function (el) {
      el.style.height = '0'
    }
  },
  data () {
    return {
      techShowMore: true,
      areaList: [
        {
          open: true,
          title: 'comp_areas_1',
          texts: [
            'comp_areas_text_1'
          ]
        },
        {
          open: false,
          title: 'comp_areas_2',
          texts: [
            'comp_areas_text_2a',
            'comp_areas_text_2b'
          ]
        },
        {
          open: false,
          title: 'comp_areas_3',
          texts: [
            'comp_areas_text_3'
          ]
        },
        {
          open: false,
          title: 'comp_areas_4',
          texts: [
            'comp_areas_text_4a',
            'comp_areas_text_4b'
          ]
        },
        {
          open: false,
          title: 'comp_areas_5',
          texts: [
            'comp_areas_text_5a',
            'comp_areas_text_5b'
          ]
        },
        {
          open: false,
          title: 'comp_areas_6',
          texts: [
            'comp_areas_text_6'
          ]
        },
        {
          open: false,
          title: 'comp_areas_7',
          texts: [
            'comp_areas_text_7'
          ]
        },
        {
          open: false,
          title: 'comp_areas_8',
          texts: [
            'comp_areas_text_8'
          ]
        }
      ],
      servicesList: [
        {
          open: true,
          title: 'comp_services_1',
          texts: [
            'comp_services_text_1'
          ]
        },
        {
          open: false,
          title: 'comp_services_2',
          texts: [
            'comp_services_text_2a',
            'comp_services_text_2b',
            'comp_services_text_2c'
          ]
        },
        {
          open: false,
          title: 'comp_services_3',
          texts: [
            'comp_services_text_3'
          ]
        }
      ],
      projects: [
        'comp_projects_1',
        'comp_projects_2',
        'comp_projects_3',
        'comp_projects_4',
        'comp_projects_5',
        'comp_projects_6',
        'comp_projects_7',
        'comp_projects_8'
      ]
    }
  }
}
</script>

<style>

.tech-enter-active, .tech-leave-active {
  transition: opacity 300ms;
}

.tech-enter, .tech-leave-to {
  opacity: 0;
}

.ui-accordion-content {
  transition: 300ms ease-in-out;
}

</style>
